import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { atxWidth$ } from '@epicuro-next/ataraxia/breakpoint';
import { MediaModule } from '@epicuro-next/ataraxia/media';
import { IMedia } from '@epicuro-next/ataraxia/models';
import { LinkInfo, urlToLinkInfo } from '@epicuro-next/utilities';
import { BehaviorSubject, combineLatest, map } from 'rxjs';

@Component({
  selector: 'atx-simple-banner',
  templateUrl: './simple-banner.component.html',
  styleUrls: ['./simple-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, MediaModule],
})
export class SimpleBannerComponent {
  @ViewChild('figure') public figureElement: ElementRef;
  @Input() public media: IMedia;
  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public set figureMaxWidth(maxWidth: number) {
    if (maxWidth) {
      this.figureMaxWidth$.next(maxWidth);
    }
  }
  @Input() public set routerLink(link: string) {
    this.linkInfo = urlToLinkInfo(link);
  }

  @Input() public disabledRouterLink = false;

  @Output() public linkClick = new EventEmitter<void>();

  private figureMaxWidth$ = new BehaviorSubject(1680);

  public isMaxWidth$ = combineLatest([atxWidth$, this.figureMaxWidth$]).pipe(
    map(([width, figureMaxWidth]) => width > figureMaxWidth),
  );

  public linkInfo: LinkInfo;

  public videoPlayerProps = {
    autoplay: true,
    controls: false,
    muted: true,
    volume: 1,
  };
}
